/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerSearchElement = {
    properties: {
        givenName: {
            type: 'string',
            isRequired: true,
        },
        familyName: {
            type: 'string',
            isRequired: true,
        },
        birthdate: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date',
            }, {
                type: 'null',
            }],
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        photo: {
            type: 'any-of',
            contains: [{
                type: 'Image',
            }, {
                type: 'null',
            }],
        },
        insiderCanModifyImage: {
            type: 'boolean',
            isRequired: true,
        },
        jersey: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        foot: {
            type: 'any-of',
            contains: [{
                type: 'FootEnum',
            }, {
                type: 'null',
            }],
        },
        height: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        rating: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        mainTeamId: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
        },
        mainTeam: {
            type: 'any-of',
            contains: [{
                type: 'TeamListMinimum',
            }, {
                type: 'null',
            }],
        },
        user: {
            type: 'any-of',
            contains: [{
                type: 'UserId',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
